import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { FacilityReitListResponseWrapper, FacilitySchema } from "./types";

const ERROR_MESSAGE = "Не удалось получить список доступных квартир в здании";

const useReitList = () => {
  async function fetchReitList(
    url: string,
    { arg }: { arg: { typeIds: number[] } }
  ) {
    try {
      const data = await fetcher.swr<FacilityReitListResponseWrapper>(url, {
        method: "POST",
        data: { typeIds: arg.typeIds.length ? arg.typeIds : undefined },
      });
      return data.data as FacilitySchema[];
    } catch (error) {
      console.log(error ,ERROR_MESSAGE)
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `facility/reit-list`,
    fetchReitList
  );

  const dataSorted = data?.sort(
    (firstItem, secondItem) => firstItem.currentPrice - secondItem.currentPrice
  );

  return {
    reitList: dataSorted ?? [],
    error,
    isMutating,
    trigger,
  };
};

export default useReitList;
